export default __webpack_public_path__ + "static/media/escudo_guatemala_fondo.64965eb9.png";